import {
  Domain,
  getAuthentication,
  getContentType,
  getDomain,
  getRequestString,
  getRequestType,
  RequestType,
  UploadFileType,
  URLType,
} from '../ApiManager';

import axios, {RawAxiosRequestHeaders} from 'axios';

class FileUploader {
  uploadFile = async <T>(
    requestType: RequestType,
    file: FormData,
    serverType: URLType = URLType.api,
    domain: Domain = getDomain(requestType),
  ) => {
    let headers: Partial<RawAxiosRequestHeaders> = {
      Accept: 'application/json',
    };

    const auth = await getAuthentication(requestType);
    if (auth) {
      headers.Authorization = auth;
    }

    const url = serverType + domain + getRequestString(requestType);

    console.log(url, headers);

    return new Promise<void>(async (resolve, reject) => {
      await axios
        .patch(url, file, {
          headers: headers,
        })
        .then(res => {
          if (res.status >= 400 && res.status < 600) {
            reject();
            return;
          }
          resolve();
        })
        .catch(err => {
          console.log(err.response);
          reject(err);
        });
    });
  };
}

const fileUploader = new FileUploader();

export default fileUploader;
